import { Button, DrawerBodyWrapper, DrawerFooterWrapper, Input, PageLevelTableWrapper, SectionHeader, Select, Table } from '@base'
import { strings } from '@constants'
import { ItemWrapper } from '@pages/Admin/Enquiry/ManageEnquiries/ManageEnquiry/PaymentTerms'
import { useEffect, useMemo, useState } from 'react'
import { BiInputFieldWrapper } from '../styles'
import { ButtonsWrapper } from '@pages/Admin/Enquiry/ManageEnquiries/ManageEnquiry/EditSupplierQuotes/styles'
import { useDispatch } from 'react-redux'
import { toggleDrawer } from '@data/state/action/root'
import { getAllCommodityApi } from '@data'
import { showLoader } from '@data/state/action'

const deriveFormState = (data) => {
	const _state = {
		product_name: {
			id: 'product-name',
			label: 'Product Name',
			placeholder: 'Enter product name',
			value: '',
			disabled: false,
			required: false,
		},
		proposed_payment_terms: {
			id: 'proposed-payment-terms',
			label: 'Proposed Payment Terms',
			placeholder: 'Enter proposed payment terms',
			value: '',
			disabled: false,
			required: false,
		},
		tentative_transaction_value: {
			id: 'tentative-transaction-value',
			label: 'Tentative Transaction Value',
			placeholder: 'Enter tentative transaction value',
			value: '',
			disabled: false,
			required: false,
		},
		limit_required: {
			id: 'limit-required',
			label: 'Limit Required',
			placeholder: 'Enter limit required',
			value: '',
			disabled: false,
			required: false,
		},
	}
	if (data) {
	}
	return _state
}
const DealDetails = ({ data, callback }) => {
	const dispatch = useDispatch()
	const [formState, setFormState] = useState(deriveFormState())
	const [dealList, setDealList] = useState([])
	const [commodityList, setcommodityList] = useState([])

	useEffect(() => {
		if (data) {
			dispatch(showLoader(true))
			setDealList(data)
			getAllCommodityApi()
				.then((response) => {
					setcommodityList(response)
				})
				.catch(() => {})
				.finally(() => {
					dispatch(showLoader(false))
				})
		}
	}, [data])

	const updateState = (key) => (value) => {
		setFormState((_s) => ({
			..._s,
			[key]: {
				..._s[key],
				value,
			},
		}))
	}

	const dealDetailsColumns = [
		{ label: 'Product Name', key: 'product_name', mobile: true },
		{ label: 'Payment Terms', key: 'proposed_payment_terms' },
		{ label: 'Tentative Transaction Value', key: 'tentative_transaction_value' },
		{ label: 'Limit Required', key: 'limit_required' },
	]

	const submitHandler = () => {
		callback(dealList)
		dispatch(toggleDrawer(false))
	}
	const clearState = () => {
		setFormState(deriveFormState())
	}

	const addDealDetailHandler = () => {
		const dealObj = {
			product_name: formState?.product_name?.value,
			proposed_payment_terms: formState?.proposed_payment_terms?.value,
			tentative_transaction_value: formState?.tentative_transaction_value?.value,
			limit_required: formState?.limit_required?.value,
		}
		setDealList((_s) => [..._s, dealObj])
		clearState()
	}

	const checkAddDisabled = useMemo(() => {
		return Boolean(
			!formState?.product_name?.value ||
				!formState?.proposed_payment_terms?.value ||
				!formState?.tentative_transaction_value?.value ||
				!formState?.limit_required?.value
		)
	}, [formState])

	const renderForm = () => {
		return (
			<ItemWrapper>
				<SectionHeader></SectionHeader>
				<BiInputFieldWrapper>
					<Select
						id={formState?.product_name?.id}
						label={formState?.product_name?.label}
						data={commodityList ?? []}
						placeholder={formState?.product_name?.placeholder}
						value={commodityList?.find((item) => formState?.product_name?.value === item.commodity_name) ?? {}}
						primaryKey='commodity_id'
						displayKey='commodity_name'
						disabled={formState?.product_name?.disabled}
						required={formState?.product_name?.required}
						onChange={(value) => updateState('product_name')(value.commodity_name)}
					/>
					<Input
						id={formState?.proposed_payment_terms?.id}
						label={formState?.proposed_payment_terms?.label}
						placeholder={formState?.proposed_payment_terms?.placeholder}
						value={formState?.proposed_payment_terms?.value}
						disabled={formState?.proposed_payment_terms?.disabled}
						required={formState?.proposed_payment_terms?.required}
						onChange={updateState('proposed_payment_terms')}
					/>
				</BiInputFieldWrapper>
				<BiInputFieldWrapper>
					<Input
						id={formState?.tentative_transaction_value?.id}
						label={formState?.tentative_transaction_value?.label}
						placeholder={formState?.tentative_transaction_value?.placeholder}
						value={formState?.tentative_transaction_value?.value}
						disabled={formState?.tentative_transaction_value?.disabled}
						required={formState?.tentative_transaction_value?.required}
						onChange={updateState('tentative_transaction_value')}
					/>
					<Input
						id={formState?.limit_required?.id}
						label={formState?.limit_required?.label}
						placeholder={formState?.limit_required?.placeholder}
						value={formState?.limit_required?.value}
						disabled={formState?.limit_required?.disabled}
						required={formState?.limit_required?.required}
						onChange={updateState('limit_required')}
					/>
				</BiInputFieldWrapper>
				<ButtonsWrapper>
					<Button xs margin={`0 0 0 0`} type='secondary' variant='' onClick={clearState}>
						{strings('cancel')}
					</Button>
					<Button xs margin={`0 0 0 auto`} disabled={checkAddDisabled} onClick={addDealDetailHandler}>
						{strings('add')}
					</Button>
				</ButtonsWrapper>
			</ItemWrapper>
		)
	}

	return (
		<>
			<DrawerBodyWrapper>
				{renderForm()}
				{dealList?.length > 0 && (
					<PageLevelTableWrapper>
						<Table
							fullHeight
							rowsToDisplay={100}
							columns={dealDetailsColumns}
							page={0}
							totalItemCount={dealList.length}
							data={dealList}
							hideFooter
						/>
					</PageLevelTableWrapper>
				)}
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button small onClick={submitHandler}>
					{strings('submit')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default DealDetails
